import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import AddPOS from "../pages/AddPOS";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import POSDetails from "../pages/POSDetails";
import ViewPOS from "../pages/ViewPOS";

import AddCattleInsurance from "../pages/AddCattleInfo";
import CattleInsuranceDetails from "../pages/CattleInsuranceDetails";
import ViewCattleDetails from "../pages/ViewCattleDetails";
import EditCattleDetails from "../pages/EditCattleDetails";
import ShareDetails from "../pages/ShareDetails";
import EndorsementDetails from "../pages/EndorsementDetails";
import ClaimDetails from "../pages/ClaimDetails";
import AddIntimateClaim from "../pages/AddIntimateClaim";
import ViewClaimDetails from "../pages/ViewClaimDetails";
import EditClaimDetails from "../pages/EditClaimDetails";
import DoctorManagement from "../pages/DoctorManagement";
import InvestigatorManagement from "../pages/InvestigatorManagement";
import RoleDetails from "../pages/RoleDetails";
import RolePermissionDetails from "../pages/RolePermissionDetails";
import AssignedCattleDoctor from "../pages/AssignedCattleDoctor";
import AssignedCattleInvestigator from "../pages/AssignedCattleInvestigator";
import DoctorRequestList from "../pages/DoctorRequestList";
import InvestigatorRequestList from "../pages/InvestigatorRequestList";
import SurveyorList from "../pages/SurveyorManagement";
import SurveyorRequestList from "../pages/SurveyorRequestList";
import AssignedCattleSurveyor from "../pages/AssignedCattleSurveyor";
import HRDashboard from "../pages/HRMSDashboard.js";
import ManagerDashboard from "../pages/Dashbaord/ManagerDashboard.js";
import EmployeeDashboard from "../pages/Dashbaord/EmployeeDashboard.js";

import Onboard from "../pages/Onboarding/Onboard.js";
import OnboardList from "../pages/Onboarding/OnboardList.js";
import ListMembers from "../pages/UserManagement/ListMembers.js";
import AddMemberPage from "../pages/UserManagement/AddMemberPage.js";
import RequestedLeaves from "../pages/Leavemanagement/RequestedLeaves.js";
import RejectedLeaves from "../pages/Leavemanagement/RejectedLeaves.js";
import ApprovedLeaves from "../pages/Leavemanagement/ApprovedLeaves.js";
import AddDepartments from "../pages/Department/Department.js";
import AddRoles from "../pages/Roles/Roles.js";
import Holidays from "../hooks/Holidays/Holiday.js";
import Attendance from "../pages/Attendance/Attendance.js";
import Payroll from "../pages/Payroll/Payroll.js";
import ViewDetails from "../pages/Onboarding/VIewDetails.js";
import CalculateSalary from "../pages/Payroll/CalculateSalary.js";
import PayrollItems from "../pages/Payroll/Addition.js";
import OnboardingForm from "../pages/Onboarding/OnboardingForm.js";
import LeaveRequests from "../pages/Manager/LeaveRequests.jsx";
import TeamMembers from "../pages/Manager/TeamMembers.jsx";
import EmployeeProfile from "../pages/Manager/EmployeeProfile.jsx";
import HRMSEmployeeHome from "../pages/HRMSEmployeeHome";
import ManagerMyInfo from "../pages/Manager/ManagerMyInfo.jsx";
import ManagerApplyLeave from "../pages/Manager/ManagerApplyLeave.jsx"; // NEW
import ManagerAttendance from "../pages/Manager/ManagerAttendance.jsx"; // NEW
import ManagerHolidays from "../pages/Manager/ManagerHolidays.jsx"; // NEW
import PayslipDownload from "../pages/EmployeePayslip/EmpPayslip.js";
// import LeaveRequests from "../pages/Manager/LeaveRequests.jsx";
import ProtectedRoute from "../components/ProtectedRoute.js";
import HRMSForgotPassword from "../pages/HRMSForgotPassword";
const AppRoutes = () => {
  return (
    <Layout>
      <Routes>
        {/* Default redirect to login to handle root path */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/pos/all" element={<POSDetails />} />
        <Route exact path="/pos/add" element={<AddPOS />} />
        <Route exact path="/pos/:id/view" element={<ViewPOS />} />
        <Route
          exact
          path="/cattle-insurance/all"
          element={<CattleInsuranceDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/add"
          element={<AddCattleInsurance />}
        />
        <Route exact path="/cattle/:id/view" element={<ViewCattleDetails />} />
        <Route exact path="/cattle/:id/edit" element={<EditCattleDetails />} />
        <Route
          exact
          path="/cattle-insurance/insurer-details"
          element={<ShareDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/insurer-details/:id"
          element={<ShareDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/endorsement"
          element={<EndorsementDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/claim"
          element={<ClaimDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/intimate-claim"
          element={<AddIntimateClaim />}
        />
        <Route exact path="/claim/:id/view" element={<ViewClaimDetails />} />
        <Route exact path="/claim/:id/edit" element={<EditClaimDetails />} />
        <Route
          exact
          path="/cattle-insurance/doctor"
          element={<DoctorManagement />}
        />
        <Route
          exact
          path="/cattle-insurance/investigator"
          element={<InvestigatorManagement />}
        />
        <Route exact path="/cattle-insurance/role" element={<RoleDetails />} />
        <Route
          exact
          path="/cattle-insurance/role-permission"
          element={<RolePermissionDetails />}
        />
        <Route
          exact
          path="/cattle-insurance/assigned-doctor"
          element={<AssignedCattleDoctor />}
        />
        <Route
          exact
          path="/cattle-insurance/assigned-investigator"
          element={<AssignedCattleInvestigator />}
        />
        <Route
          exact
          path="/cattle-insurance/assigned-surveyor"
          element={<AssignedCattleSurveyor />}
        />
        <Route
          exact
          path="/cattle-insurance/doctor-dashboard"
          element={<DoctorRequestList />}
        />
        <Route
          exact
          path="/cattle-insurance/investigator-dashboard"
          element={<InvestigatorRequestList />}
        />
        <Route
          exact
          path="/cattle-insurance/surveyor-dashboard"
          element={<SurveyorRequestList />}
        />
        <Route
          exact
          path="/cattle-insurance/surveyor"
          element={<SurveyorList />}
        />

        <Route
          exact
          path="/hrms/dashboard"
          element={
            <ProtectedRoute allowedRoles={["HR"]}>
              <HRDashboard />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/hrms/home" element={<HRMSEmployeeHome />} /> */}
        <Route
          exact
          path="/hrms/home"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <HRMSEmployeeHome />
            </ProtectedRoute>
          }
        />

        {/* <Route
          exact
          path="/hrms/manager-dashboard"
          element={<ManagerDashboard />}
        />
        <Route exact path="/hrms/manager/my-info" element={<ManagerMyInfo />} />
        <Route
          exact
          path="/hrms/manager/apply-leave"
          element={<ManagerApplyLeave />}
        /> */}
        {/* <Route
          exact
          path="/hrms/manager/my-attendance"
          element={<ManagerAttendance />}
        />
        <Route
          exact
          path="/hrms/manager/holidays"
          element={<ManagerHolidays />}
        />
        <Route
          exact
          path="/manager/leave-requests"
          element={<LeaveRequests />}
        /> */}
        {/* <Route exact path="/manager/team-members" element={<TeamMembers />} />
        <Route
          exact
          path="/manager/employee/:employeeId"
          element={<EmployeeProfile />}
        /> */}
        <Route
          exact
          path="/hrms/manager-dashboard"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/manager/my-info"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerMyInfo />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/hrms/manager/payslip"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <PayslipDownload />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/employee/my-info"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <ManagerMyInfo />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/manager/apply-leave"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerApplyLeave />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/manager/my-attendance"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerAttendance />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/manager/holidays"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerHolidays />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/manager/leave-requests"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <LeaveRequests />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/manager/team-members"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <TeamMembers />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/manager/employee/:employeeId"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <EmployeeProfile />
            </ProtectedRoute>
          }
        />
        {/* Employee Routes */}
        {/* <Route
          exact
          path="/hrms/employee-dashboard"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        /> */}
        <Route
          exact
          path="/hrms/employee-dashboard"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <ManagerMyInfo />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/employee/my-attendance"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <ManagerAttendance />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/employee/apply-leave"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <ManagerApplyLeave />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/employee/holidays"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <ManagerHolidays />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/hrms/employee/payslip"
          element={
            <ProtectedRoute allowedRoles={["EMPLOYEE"]}>
              <PayslipDownload />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="/hrms/employee-dashboard"
          element={<EmployeeDashboard />}
        />
        <Route
          exact
          path="/hrms/employee/my-attendance"
          element={<ManagerAttendance />}
        />
        <Route
          exact
          path="/hrms/employee/apply-leave"
          element={<ManagerApplyLeave />}
        />
        <Route
          exact
          path="/hrms/employee/holidays"
          element={<ManagerHolidays />}
        /> */}
        {/* <Route
          exact
          path="/hrms/forgot-password"
          element={<HRMSForgotPassword />}
        /> */}
        {/* <Route
          exact
          path="hrms/Onboarding/Add-Employee"
          element={<Onboard />}
        /> */}
        {/* <Route
          exact
          path="hrms/Onboarding/Add-Employee"
          element={<OnboardingForm />}
        /> */}
        <Route
          exact
          path="hrms/Onboarding/Add-Employee"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <OnboardingForm />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="hrms/Onboarding/OnboardList"
          element={<OnboardList />}
        /> */}
        <Route
          exact
          path="hrms/Onboarding/OnboardList"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <OnboardList />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="/hrms/user-management/list-members"
          element={<ListMembers />}
        /> */}
        <Route
          exact
          path="/hrms/user-management/list-members"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <ListMembers />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="/hrms/user-management/add-member"
          element={<AddMemberPage />}
        /> */}
        <Route
          exact
          path="/hrms/user-management/add-member"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <AddMemberPage />
            </ProtectedRoute>
          }
        />

        {/* <Route
          exact
          path="/hrms/Leave-management/Requested-Leaves"
          element={<RequestedLeaves />}
        /> */}
        <Route
          exact
          path="/hrms/Leave-management/Requested-Leaves"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <RequestedLeaves />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="/hrms/Leave-management/Rejected-Leaves"
          element={<RejectedLeaves />}
        /> */}
        <Route
          exact
          path="/hrms/Leave-management/Rejected-Leaves"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <RejectedLeaves />
            </ProtectedRoute>
          }
        />
        {/* <Route
          exact
          path="/hrms/Leave-management/Approved-Leaves"
          element={<ApprovedLeaves />}
        /> */}
        <Route
          exact
          path="/hrms/Leave-management/Approved-Leaves"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <ApprovedLeaves />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/hrms/Department" element={<AddDepartments />} />
         */}
        <Route
          exact
          path="/hrms/Department"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <AddDepartments />
            </ProtectedRoute>
          }
        />

        {/* <Route exact path="/hrms/Roles" element={<AddRoles />} /> */}
        <Route
          exact
          path="/hrms/Roles"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <AddRoles />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/hrms/Holidays" element={<Holidays />} />
        <Route exact path="/hrms/Attendance" element={<Attendance />} />
        <Route exact path="/hrms/payroll" element={<Payroll />} />
        <Route exact path="/hrms/Addition" element={<PayrollItems />} />
        <Route exact path="/hrms/CalulateSlary" element={<CalculateSalary />} /> */}
        <Route
          exact
          path="/hrms/Holidays"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <Holidays />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/Attendance"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <Attendance />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/payroll"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <Payroll />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/Addition"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <PayrollItems />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/hrms/CalulateSlary"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <CalculateSalary />
            </ProtectedRoute>
          }
        />

        {/* <Route
          exact
          path="/hrms/Onboarding/ViewDetails"
          element={<ViewDetails />}
        ></Route> */}
        <Route
          exact
          path="/hrms/Onboarding/ViewDetails"
          element={
            <ProtectedRoute allowedRoles={["HR", "admin"]}>
              <ViewDetails />
            </ProtectedRoute>
          }
        />
        {/* Catch-all: redirect unknown routes to /login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Layout>
  );
};

export default AppRoutes;
